
import { apiFetch } from './client';
import type { Agent, AgentCreate, AgentUpdate } from '../types/contracts';

export const agentsApi = {
  list:      ()                        => apiFetch<Agent[]>('/api/agents'),
  get:       (id: string)              => apiFetch<Agent>(`/api/agents/${id}`),
  create:    (d: AgentCreate)          => apiFetch<Agent>('/api/agents', { method: 'POST', body: JSON.stringify(d) }),
  update:    (id: string, d: AgentUpdate) => apiFetch<Agent>(`/api/agents/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  setEnabled:(id: string, enabled: boolean) =>
    apiFetch<void>(`/api/agents/${id}/enabled`, { method: 'POST', body: JSON.stringify({ enabled }) }),
  test:      (id: string, input: string) =>
    apiFetch<{ output: string }>(`/api/agents/${id}/test`, { method: 'POST', body: JSON.stringify({ input }) }),
};
